<template>
	<div>
		<el-table
			ref="table"
			class="conversation-list"
			:data="conversationSortByTimestamp"
			:resizable="false"
			:show-header="isHeader"
			highlight-current-row
			border
			v-loading="loading"
			:height="height"
			@row-click="handleRowClick($event)"
			@row-contextmenu="handleContextmenu"
			:row-class-name="isTopClassName"
		>
			<el-table-column :label="$t('conversationList.recentChat')">
				<template slot-scope="scope">
					<div class="item-container">
						<div class="item-left">
							<ChatAvatar :type="scope.row.object_type" :avatar="scope.row.object_avatar" borderRadius="50%" size="35" class="avatar" />
						</div>
						<div class="item-content">
							<div class="name-warp" :title="getTitle(scope.row, 1)">
								<span v-if="!scope.row.note">{{ scope.row.object_name }} </span>
								<span v-if="scope.row.note" :title="getTitle(scope.row, 2)">{{ scope.row.note }}</span>
								<span>{{ scope.row.object_phone_number }}</span>
							</div>
							<div class="description-warp">
								<div class="description" v-if="scope.row.object_type == 'personal' && scope.row.customers">
									<div
										class="customer-name"
										:title="item.customer_name"
										v-bind:key="item.customer_id"
										v-for="item in scope.row.customers.slice(0, 1)"
									>
										{{ item.customer_id | removeFrontZero }} {{ item.customer_name }}
									</div>
									<div class="more-button-wrap">
										<i class="el-icon-more" v-if="scope.row.customers.length > 1" @click="handleMoreCustomer(scope.row)" />
									</div>
								</div>
							</div>
						</div>
						<div class="item-right">
							<span class="last-message-timestamp">{{ scope.row.last_message_timestamp | conversationDateFormat }}</span>
							<div class="badge-wrap">
								<el-badge class="badge" :value="scope.row.unread_count" :hidden="!scope.row.unread_count" :max="99" />
							</div>
						</div>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<vue-simple-context-menu :elementId="'conversation-list-menu'" :options="options" :ref="'contextMenu'" @option-clicked="handleOptionClicked" />
	</div>
</template>

<script>
import ChatAvatar from "./chat-avatar.vue";
import { putChatStick, deleteChatStick, putUnreadChat } from "@/services/api-v2/api-v2";
import _ from "lodash";

export default {
	components: {
		ChatAvatar,
	},

	name: "ConversationList",

	props: {
		data: {
			type: Array,
			required: true,
		},
		loading: {
			type: Boolean,
			required: false,
			default: false,
		},
		height: {
			type: Number,
			required: false,
			default: null,
		},
		isHeader: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data() {
		return {
			options: [],
		};
	},

	methods: {
		/**
		 *避免鼠标悬停时重复显示电话号码
		 * @param row
		 * @param type type == 1时返回昵称 + 电话号码； type == 2 时返回带有“备注名”前缀的备注名 + 电话号码
		 */
		getTitle(row, type) {
			const phone = row.object_phone_number ? this.$t("customerPhone.telephoneNumber") + row.object_phone_number : "";
			if (type === 1) {
				if (row.note) {
					return row.object_name;
				}
				return row.object_name + phone;
			} else if (type == 2) {
				return this.$t("conversationList.remarkName") + row.note + phone;
			}
		},
		handleRowClick(event) {
			this.$emit("row-click", event);
		},

		handleMoreCustomer(event) {
			this.$emit("more-customer-click", event);
		},

		setCurrentRow(row) {
			this.$refs.table.setCurrentRow(row);
		},

		//聊天对话添加置顶样式类名
		isTopClassName({ row }) {
			if (row.is_top) {
				return "istop";
			}
		},

		// 聊天对话右键
		handleContextmenu(row, _column, event) {
			if (row.is_top) {
				if (row.unread_count) {
					this.options = [
						{
							name: this.$t("conversationList.cancelStick"),
							slug: "cancelStick",
						},
						{
							name: this.$t("conversationList.haveRead"),
							slug: "read",
						},
					];
				} else {
					this.options = [
						{
							name: this.$t("conversationList.cancelStick"),
							slug: "cancelStick",
						},
						{
							name: this.$t("conversationList.unread"),
							slug: "unread",
						},
					];
				}
			} else {
				if (!row.unread_count) {
					this.options = [
						{
							name: this.$t("conversationList.stick"),
							slug: "stick",
						},
						{
							name: this.$t("conversationList.unread"),
							slug: "unread",
						},
					];
				} else {
					this.options = [
						{
							name: this.$t("conversationList.stick"),
							slug: "stick",
						},
						{
							name: this.$t("conversationList.haveRead"),
							slug: "read",
						},
					];
				}
			}
			event.preventDefault();
			Object.defineProperty(event, "pageX", {
				value: event.pageX - 240,
				writable: true,
			});
			Object.defineProperty(event, "pageY", {
				value: event.pageY - 210,
				writable: true,
			});
			this.$refs.contextMenu.showMenu(event, row);
		},

		// 聊天对话右键功能
		handleOptionClicked(event) {
			switch (event.option.slug) {
				case "stick":
					this.chatStick(event.item);
					break;
				case "cancelStick":
					this.cancelChatStick(event.item);
					break;
				case "unread":
					this.unreadChat(event.item);
					break;
				case "read":
					this.readChat(event.item);
					break;
			}
		},

		//聊天对话置顶
		async chatStick(item) {
			try {
				await putChatStick(item.id);
				item.is_top = true;
				this.$message.success(this.$t("conversationList.pinnedSuccessfully"));
			} catch (error) {
				this.$message.error(error);
			}
		},

		//聊天对话取消置顶
		async cancelChatStick(item) {
			try {
				await deleteChatStick(item.id);
				item.is_top = false;
				this.$message.success(this.$t("conversationList.unpinnedSuccessfully"));
			} catch (error) {
				this.$message.error(error);
			}
		},

		//聊天对话设置未读事件
		async unreadChat(item) {
			try {
				await putUnreadChat(item.id, 1);
				item.unread_count = 1;
				this.$store.commit("INCREMENT_TOTAL_UNREAD", 1);
			} catch (error) {
				this.$message.error(error);
			}
		},

		//聊天对话设置已读事件
		async readChat(item) {
			try {
				await putUnreadChat(item.id, 0);
				item.unread_count = 0;
				this.$store.commit("DECREMENT_TOTAL_UNREAD", 0);
			} catch (error) {
				this.$message.error(error);
			}
		},
	},
	computed: {
		conversationSortByTimestamp() {
			return _.orderBy(this.data, ["is_top", "last_message_timestamp"], ["desc", "desc"]);
		},
	},
};
</script>

<style lang="less" scoped>
.item-container {
	flex: 1;
	display: flex;
	gap: 10px;
	align-items: center;
	cursor: pointer;
	height: 50px;
}

.item-left {
	display: flex;
}

.item-content {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-items: center;
	overflow: hidden;

	.name-warp {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.description-warp {
		flex: 1;
		display: flex;

		.description {
			width: 100%;
			display: flex;

			.customer-name {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-size: 12px;
				color: #808080;
			}

			.more-button-wrap {
				display: flex;
				justify-content: right;
				align-items: flex-end;
				width: 30px;
			}
		}
	}
}

.item-right {
	display: flex;
	width: 60px;
	height: 100%;
	flex-direction: column;
	justify-items: center;
	align-items: center;

	.last-message-timestamp {
		flex: 1;
		font-size: 9px;
		color: #dcdcdc;
	}

	.badge-wrap {
		display: flex;
		flex: 1;
		padding-top: 5px;
		.badge {
			flex: 1;
		}
	}
}

/deep/ .conversation-list .istop {
	background-color: #f5f7fa;
}
</style>
